module.exports = __webpack_public_path__ + "static/media/flickr.03cc43e9.svg";